import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { FaEdit, FaTrash  } from "react-icons/fa";
import { faSearch } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { toast } from "react-toastify";
import { AlertConfirmation } from "../../../common/Alert";
import "react-toastify/dist/ReactToastify.css";
import Loader from "../../../components/Loader";
import { getAllBanks, deleteAgent, deleteBank } from "../../../middleware/backend_hepler";
import Paginations from "../../../components/Paginations";


const BankList = () => {
  const [banks, setBankLists] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");
  const [messageDisplayed, setMessageDisplayed] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [banksPerPage, setBanksPerPage] = useState(10);
  const [showConfirm, setShowConfirm] = useState(false);
  const [deleteBankId, setDeleteBankId] = useState(null);
  const navigate = useNavigate();
  const location = useLocation();

  const fetchBanks = async () => {
    try {
      const response = await getAllBanks();
      setBankLists(response.data);
      setLoading(false);
    } catch (error) {
      setError("Error fetching bank lists.");
      setLoading(false);
    }
  };

  useEffect(() => {
    setLoading(true);
    fetchBanks();
  }, []);

  React.useEffect(() => {
    if (location.state?.successMessage && !messageDisplayed) {
      toast.success(location.state.successMessage);
      setMessageDisplayed(true);
      navigate(location.pathname, { replace: true, state: {} });
    }
  }, [location.state, navigate, messageDisplayed]);

  const filteredBanks = banks.filter((bank) =>
    bank.bank_name?.toLowerCase().includes(searchQuery)
  );

  const indexOfLastBank = currentPage * banksPerPage;
  const indexOfFirstBank = indexOfLastBank - banksPerPage;
  const currentBanks = filteredBanks.slice(indexOfFirstBank, indexOfLastBank);

  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value.toLowerCase());
  };

  const handleCreateBank = () => {
    navigate("/create-bank");
  };

  const handleEdit = (id) => {
    navigate(`/edit-bank/${id}`);
  };

  const handleDelete = async (bankId) => {
    try {
      setLoading(true);
      const response = await deleteBank(bankId);
      if (response) {
        toast.success("Bank deleted successfully!");
        fetchBanks();
        setLoading(false);
      } else {
        toast.error("Failed to delete bank.");
        setLoading(false);
      }
    } catch (error) {
      console.error("Error deleting bank:", error);
      toast.error("An error occurred while deleting the bank.");
    }
  };

  if (loading) {
    return <Loader />;
  }
  if (error) {
    return <div>{error}</div>;
  }

  return (
    <div className="home-loan-screen">
      <h4 className="agent-title">Bank</h4>
      <div className="agent">
        <div className="search-bar">
          <input
            type="text"
            placeholder="Search by Bank Name"
            value={searchQuery}
            onChange={handleSearchChange}
          />
          <FontAwesomeIcon icon={faSearch} className="search-icon" />
        </div>
        <button className="agent-button" onClick={handleCreateBank}>
          <span className="plus-icon">+</span> Add Bank
        </button>
      </div>

      <div className="table-container">
        <table className="table">
          <thead>
            <tr>
              <th>Bank ID</th>
              <th>Bank Name</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {currentBanks.length > 0 ? (
              currentBanks.map((bank, index) => (
                <tr
                  key={index}
                  onClick={() => handleEdit(bank.bank_id || index + 1)}
                  style={{ cursor: "pointer" }}
                >
                  <td>{bank.bank_id ? bank.bank_id : index + 1}</td>
                  <td>{bank.bank_name}</td>
                  <td>
                    <FaEdit
                      className="edit-icon"
                      onClick={(e) => {
                        e.stopPropagation();
                        handleEdit(bank.bank_id || index + 1);
                      }}
                      style={{ cursor: "pointer" }}
                    />
                    <span>
                      <FaTrash
                        className="delete-icon"
                        onClick={(e) => {
                          e.stopPropagation();
                          setDeleteBankId(bank.bank_id);
                          setShowConfirm(true);
                        }}
                        style={{ cursor: "pointer" }}
                      />
                    </span>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="8" style={{ textAlign: "center" }}>
                  No banks found.
                </td>
              </tr>
            )}
          </tbody>
        </table>
        <Paginations
          perPageData={banksPerPage}
          data={filteredBanks}
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          isShowingPageLength={true}
          paginationDiv="pagination-container"
          paginationClass="pagination"
        />
        {showConfirm && (
          <AlertConfirmation
            message={`Are you sure you want to <br /> delete this bank?`} 
            onConfirm={async () => {
              await handleDelete(deleteBankId);
              setShowConfirm(false);
              setDeleteBankId(null);
            }}
            onCancel={() => {
              setShowConfirm(false);
              setDeleteBankId(null);
            }}
          />
        )}
      </div>
    </div>
  );
};

export default BankList;

